import React, { useContext } from 'react';
import HeaderSection from './HeaderSection';
import OverviewSection from './OverviewSection';
import IDCardSection from './IDCardSection';
import FooterSection from './FooterSection';
import './EndorsementThankYou.css';
import { RemoveVehicleContext } from '../RemoveVehicleContext/RemoveVehicleContext';
import { AddVehicleContext } from '../AddVehicleContext/AddVehicleContext';
import { ReplaceVehicleContext } from '../ReplaceVehicleContext/ReplaceVehicleContext';
import CancellationRequestSection from './CancellationRequestSection';

const EndorsementThankYou = () => {
  var screen = window.location.pathname.split("/").pop()
  var requestContext = (screen?.includes("remove")) ? RemoveVehicleContext : (screen?.includes("replace")) ? ReplaceVehicleContext : AddVehicleContext
  var endorsementType = (screen?.includes("remove")) ? "Remove Vehicle" : (screen?.includes("replace")) ? "Replace Vehicle" : "Add Vehicle"
  var endorsementClassStr = (screen?.includes("remove")) ? "removeVehicleClass" : (screen?.includes("replace")) ? "replaceVehicleClass" : "addVehicleClass"
  var { getTodaysDate } = useContext(requestContext);
  const changeContext = useContext(requestContext);
  const currentDate = getTodaysDate();

  return (
    <div className="endorsement-thank-you">
      <HeaderSection currentDate={currentDate} />
      {
        (endorsementType == "Remove Vehicle" && changeContext?.removeVehicleClass?.vehicles.vehiclesOnPolicy.storedVehicles.length == 1) ?
        <>
          <CancellationRequestSection/>
        </>
        :
        <>
          <OverviewSection requestContext={requestContext} endorsementClassStr={endorsementClassStr} endorsementType={endorsementType} />
          <IDCardSection requestContext={requestContext} endorsementClassStr={endorsementClassStr} endorsementType={endorsementType} />
        </>
      }
      <FooterSection />
    </div>
  );
};

export default EndorsementThankYou;